import { useQuery } from "react-query";
import {
    ParamsGetMetodePembayaran,
    GetMetodePembayaranResponse,
} from "../../constants/types";
import axios from "../axios";
import qs from "query-string";

const handleRequest = async (params: ParamsGetMetodePembayaran) => {
    const apiGetMetodePembayaran = qs.stringifyUrl({
        url: "api/metode-bayar",
        query: {
            ukmId: params.ukmId,
            search: `${params.search}`,
            size: params.size,
            page: params.page,
        },
    });
    const { data } = await axios.get<GetMetodePembayaranResponse>(
        apiGetMetodePembayaran,
    );
    return data.data;
};

export default function useMetodePembayaran(params: ParamsGetMetodePembayaran) {
    return useQuery<GetMetodePembayaranResponse["data"]>(
        ["metode-pembayaran", "list", params],
        () => handleRequest(params),
        {
            enabled: !!params?.ukmId,
        },
    );
}
